// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"0763ad2c","247":"bcbf7e6c","252":"f97ad4c3","338":"67e442f7","556":"cc80304f","610":"1b9f123a","820":"1b582e3f","861":"eb7c2c3b","949":"617dbb8d"}[chunkId] + ".chunk.js";
};